import React from 'react';
import { ArrowTooltip } from '@cuemath/intel';

const ArrowTooltipHOC = (remainHidden, component, child) => {
  return (
    <ArrowTooltip
      maxWidth={160}
      position="right"
      Component={component}
      remainHidden={remainHidden || undefined}
    >
      {child}
    </ArrowTooltip>
  );
};

export default ArrowTooltipHOC;
